
import { throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorModel } from '@generativ/much-smarter-models';


@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {

  constructor() { }

  handleError (errorResponse: HttpErrorResponse | any) {
    let err;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = <ErrorModel.BaseError> errorResponse.error;
      // In the case error is a Base Error from api, we should return it.
      if (error && error.developerMessage) {
        err = error;
      } else {
        err  = `${errorResponse.status} - ${errorResponse.statusText || ''} ${errorResponse.message.toString()}`;
      }
    } else {
      err = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(err);
    return observableThrowError(err);
  }
}
